import { Box, TextareaAutosize, Typography } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { textAreaStyle } from '../../constants/styleConstants'
import { AppDispatch } from '../../store'
import questionsSelector from '../../store/questions/questionsSelector'
import {
  updateNewCaseAnswerText,
  updateVictimAnswerText,
} from '../../store/questions/questionsSlice'
import { findItemByUuid } from '../../store/reports/reportsSlice'
import { IQuestionV2, MainObject } from '../../store/reports/types'
import LabelErrorTAG from '../LabelErrorTAG'
import colors from '../../constants/colors'

interface IOpenQuestion {
  question: IQuestionV2
  answers?: MainObject[]
  victimQuestionId?: number | null
}

const OpenQuestion: React.FC<IOpenQuestion> = ({ question, answers, victimQuestionId = null }) => {
  /* eslint-disable */
  // // console.log("ANSWERS FROM OPEN QUESTION : ",answers);
  const getAnswer = () => {
    if (victimQuestionId) {
      return useSelector(questionsSelector.getVictimAnswer(victimQuestionId, question?.uuid))
    }
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, question?.uuid)
    }
    return useSelector(questionsSelector.answerToNewCaseQuestion(question?.uuid))
  }
  const answer = getAnswer()
  const dispatch = useDispatch<AppDispatch>()

  const onChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (victimQuestionId) {
      dispatch(
        updateVictimAnswerText({
          victimId: victimQuestionId,
          answerUUID: answer?.uuid,
          answerText: e.target.value,
        }),
      )
      return
    }
    dispatch(
      updateNewCaseAnswerText({
        answerUUID: answer?.uuid,
        answerText: e.target.value as unknown as number,
      }),
    )
  }

  return (
    <Box
      sx={{ width: '100%', marginBottom: '3.6rem', paddingTop: '2rem', boxSizing: 'border-box' }}
    >
      {!question.is_root && !question?.label && !question?.placeholder && (
        <Typography variant='bodyBold' color={colors.TAG_BLUE}>
          {question?.text_third}
        </Typography>
      )}
      <LabelErrorTAG
        label={
          question?.label ? question?.label : question?.placeholder ? question?.placeholder : ''
        }
      />
      <TextareaAutosize
        onChange={onChangeHandler}
        value={answer?.answer.text}
        style={textAreaStyle}
        minRows={5}
        placeholder={'Description'}
      />
    </Box>
  )
}

export default OpenQuestion
